/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

String.prototype.CIAI = function () {
  return this.toLowerCase()
    .replace(/[áàãâä]/gi, "a")
    .replace(/[éè¨ê]/gi, "e")
    .replace(/[íìïî]/gi, "i")
    .replace(/[óòöôõ]/gi, "o")
    .replace(/[úùüû]/gi, "u")
    .replace(/[ç]/gi, "c")
    .replace(/[ñ]/gi, "n")
    .replace(/[^a-zA-Z0-9]/g, " ");
}

const getters = {

  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1600) return "xxl";
    else if (state.windowWidth >= 1400) return "1xl";
    else if (state.windowWidth >= 1200) return "xl";
    else if (state.windowWidth >= 992) return "lg";
    else if (state.windowWidth >= 768) return "md";
    else if (state.windowWidth >= 576) return "sm";
    else return "xs";
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },

  getParameter: state => paramSearch => {
    const result = state.parameters.filter((parameter) => parameter.id === paramSearch)
    return result.length ? result.pop() : []
  },

  /*
    refinedProductsList: state => {
      if (state.productSearch != "") {
        return state.products.filter(item => (item.name.CIAI().indexOf(state.productSearch.CIAI()) !== -1 || item.isbn.indexOf(state.productSearch) !== -1));
      } else {
        var list = state.products;
        if (state.priceRange) {
          list = list.filter(item => item.price >= state.priceRange.min && item.price <= state.priceRange.max);
        }
        if (state.version) {
          list = list.filter(item => item.versionId && item.versionId == state.version.id);
        }
        if (state.selectedCategory) {
          list = list.filter(item => item.categories && item.categories.split(',').includes(state.selectedCategory.id));
        }
        return list;
      }
    }
  */

  fullProductsList: state => {
    var list = [];
    if (state.products) {
      if (state.products.list) {
        // list = state.products.list.filter(item => (item.status == 'ACT'));
        state.products.list.filter(item => (item.status == 'ACT')).forEach(function (item) {
          const categoryIds = state.categories.list.filter(category => (item.categories.split(',').includes(category.id.toString())));
          const versionIds = state.versions.list.filter(version => (version.id.toString() == item.versionId));
          const videoURL = item.hasOwnProperty('videoURL') ? item.videoURL : '';
          if (item.hasOwnProperty(('onSale')) && item.hasOwnProperty('salePrice')) {
            list.push({...item, ...{categoryIds: categoryIds, versionIds: versionIds, originalPrice: item.price, price: item.salePrice, videoURL: videoURL}});
          } else {
            list.push({...item, ...{categoryIds: categoryIds, versionIds: versionIds, onSale: false, salePrice: item.price, originalPrice: item.price, videoURL: videoURL}});
          }
        });
      }
    }
    return list;
  },

  promotionProducts: (state, getters) => {
    return getters.fullProductsList.filter(item => (item.onSale));
  },

  showcaseProducts: (state,getters) => {
    let list = [];
    let products = [];
    if (getters.fullProductsList.length > 0 && state.showcaseProducts.list.length > 0) {
      state.showcaseProducts.list.forEach(item => {
        products = getters.fullProductsList.filter(product => (product.id == item.productId));
        if (products.length > 0) {
          list.push({...item, ...products[0]});
        }
      })
    }
    return list;
  },

  showcaseCategories: state => {
    let list = [];
    if (state.categories) {
      if (state.categories.list) {
         list = [...state.categories.list.filter(item => (item.showcase))];
      }
    }
    return list;
  },

  sliderCategories: state => {
    let list = [];
    let count = 0;
    if (state.products) {
      if (state.products.list) {
        if (state.sliderCategories) {
          state.sliderCategories.categories.split(',').forEach(function (categoryId) {
            count = 0;
            state.products.list.filter(item => (item.status == 'ACT' && item.categories.includes(categoryId)))
              .map((a) => ({sort: Math.random(), value: a}))
              .sort((a, b) => a.sort - b.sort)
              .map((a) => a.value)
              .forEach(function (item) {
              count++;
              if (count <= state.sliderCategories.maxByCategory) {
                if (item.hasOwnProperty(('onSale')) && item.hasOwnProperty('salePrice')) {
                  list.push({...item, ...{originalPrice: item.price, price: item.salePrice}});
                } else {
                  list.push({...item, ...{onSale: false, salePrice: item.price, originalPrice: item.price}});
                }
              }
            });
          });
        }
      }
    }
    return list
      .map((a) => ({sort: Math.random(), value: a}))
      .sort((a, b) => a.sort - b.sort)
      .map((a) => a.value);
  },

  refinedProductsList: state => {
    var list = [];
    if (state.products) {
      if (state.products.list) {
        // list = state.products.list.filter(item => (item.status == 'ACT'));
        state.products.list.filter(item => (item.status == 'ACT')).forEach(function (item) {
          if (item.hasOwnProperty(('onSale')) && item.hasOwnProperty('salePrice')) {
            list.push({...item, ...{originalPrice: item.price, price: item.salePrice}});
          } else {
            list.push({...item, ...{onSale: false, salePrice: item.price, originalPrice: item.price}});
          }
        });
        if (state.products) {
          if (state.productSearch != "") {
            return list.filter(item => (item.name.CIAI().indexOf(state.productSearch.CIAI()) !== -1 || item.isbn.indexOf(state.productSearch) !== -1));
          } else {
            if (state.priceRange) {
              list = list.filter(item => item.price >= state.priceRange.min && item.price <= state.priceRange.max);
            }
            if (state.version) {
              list = list.filter(item => item.versionId && item.versionId == state.version.id);
            }
            if (state.selectedCategory) {
              list = list.filter(item => item.categories && item.categories.split(',').includes(state.selectedCategory.id));
            }
          }
        }
      }
    }
    return list;
  },

  getProduct: (state, getters) => paramSearch => {
    let result = [];
    if (getters.fullProductsList) {
      result = getters.fullProductsList.filter((product) => product.id === paramSearch);
    }
    return result.length ? result.pop() : {id: 0, name: '', price: 0, onSale: false, originalPrice: 0, salePrice: 0};
  },
};

export default getters
